export const EVENT_CLIENT_REQUEST_UPDATE = 'clientRequest.update'
export const EVENT_CLIENT_REQUEST_CREATE = 'clientRequest.create'
